import {TNullable} from '@shared/interfaces/base';

export const BaseEnvironment = {
  production: false,
  emailSupport: 'suport@fbfast.io',
  ENDPOINT_PAGE_TERMS: 'https://fbfast.io/terms',
  ENDPOINT_PAGE_PRIVACY_POLICY: 'https://fbfast.io/privacy',
  ENDPOINT_PAGE_COOKIES: 'https://fbfast.io/cookie',
  ENDPOINT_BASE_SITE: 'https://fbfast.io',
  SENTRY_DSN: null as TNullable<string>,
};
